var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transport-capacity" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "search-area" },
          [
            _c(
              "el-form",
              { attrs: { inline: true, model: _vm.searchForm } },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "车牌号", clearable: "" },
                      model: {
                        value: _vm.searchForm.vehicleNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "vehicleNumber", $$v)
                        },
                        expression: "searchForm.vehicleNumber",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "能源类型", clearable: "" },
                        model: {
                          value: _vm.searchForm.energyType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "energyType", $$v)
                          },
                          expression: "searchForm.energyType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "新能源", value: "新能源" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "汽油", value: "汽油" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "柴油", value: "柴油" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.resetSearch } }, [
                      _vm._v("重置"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "160px" },
                  attrs: {
                    type: "date",
                    placeholder: "选择日期",
                    "value-format": "yyyy-MM-dd",
                  },
                  on: { change: _vm.handleDateChange },
                  model: {
                    value: _vm.searchForm.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "date", $$v)
                    },
                    expression: "searchForm.date",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("新增车辆")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "stats-cards" }, [
          _c("div", { staticClass: "stats-card total" }, [
            _c("div", { staticClass: "stats-icon" }, [
              _c("i", { staticClass: "el-icon-truck" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-content" }, [
              _c("div", { staticClass: "stats-number" }, [
                _vm._v(_vm._s(_vm.statsData.totalVehicles)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-label" }, [_vm._v("总车辆")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-card available" }, [
            _c("div", { staticClass: "stats-icon" }, [
              _c("i", { staticClass: "el-icon-success" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-content" }, [
              _c("div", { staticClass: "stats-number" }, [
                _vm._v(_vm._s(_vm.statsData.availableVehicles)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-label" }, [_vm._v("可用车辆")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-card busy" }, [
            _c("div", { staticClass: "stats-icon" }, [
              _c("i", { staticClass: "el-icon-time" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-content" }, [
              _c("div", { staticClass: "stats-number" }, [
                _vm._v(_vm._s(_vm.statsData.busyVehicles)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-label" }, [_vm._v("工作车辆")]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "view-switch" },
          [
            _c(
              "el-radio-group",
              {
                attrs: { size: "small" },
                on: { change: _vm.handleViewModeChange },
                model: {
                  value: _vm.viewMode,
                  callback: function ($$v) {
                    _vm.viewMode = $$v
                  },
                  expression: "viewMode",
                },
              },
              [
                _c("el-radio-button", { attrs: { label: "table" } }, [
                  _vm._v("列表视图"),
                ]),
                _vm._v(" "),
                _c("el-radio-button", { attrs: { label: "map" } }, [
                  _vm._v("地图视图"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.viewMode === "map",
                expression: "viewMode === 'map'",
              },
            ],
            staticClass: "vehicle-map-wrapper",
          },
          [
            _c("div", {
              staticClass: "vehicle-map",
              attrs: { id: "vehicleMapContainer" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "vehicle-map-legend" }, [
              _c("span", { staticClass: "legend-item" }, [
                _c("span", { staticClass: "legend-dot normal" }),
                _vm._v("正常"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "legend-item" }, [
                _c("span", { staticClass: "legend-dot repair" }),
                _vm._v("维修"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "legend-item" }, [
                _c("span", { staticClass: "legend-dot rest" }),
                _vm._v("休息"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.viewMode === "table",
                expression: "viewMode === 'table'",
              },
            ],
            staticClass: "table-container",
          },
          [
            _c("div", { staticClass: "table-header" }, [
              _c("div", { staticClass: "table-title" }, [
                _vm._v("车辆运力情况"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-stats" }, [
                _vm._v(
                  " 显示 " +
                    _vm._s(_vm.tableData.length) +
                    " 辆车，" +
                    _vm._s(_vm.dateList.length) +
                    " 天排班 "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                key: _vm.dateList.join(","),
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "max-height": _vm.tableHeight,
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "操作", width: "120", fixed: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#F56C6C" },
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "carNumber",
                    label: "车辆信息",
                    width: "120",
                    fixed: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "vehicle-info" }, [
                            _c("div", { staticClass: "vehicle-no" }, [
                              _vm._v(_vm._s(scope.row.carNumber)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "vehicle-brand" }, [
                              _vm._v(
                                _vm._s(scope.row.brand) +
                                  " " +
                                  _vm._s(scope.row.style)
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "location", label: "当前定位", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "location-info" }, [
                            _c("i", {
                              staticClass: "el-icon-location",
                              staticStyle: {
                                color: "#409EFF",
                                "margin-right": "4px",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "location-text" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.coordinateX && scope.row.coordinateY
                                    ? scope.row.coordinateY +
                                        ", " +
                                        scope.row.coordinateX
                                    : "未知"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "spec", label: "规格参数", width: "220" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "spec-col" }, [
                            _c("div", { staticClass: "spec-item" }, [
                              _c("span", { staticClass: "spec-label" }, [
                                _vm._v("能源："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "spec-value" }, [
                                _vm._v(_vm._s(scope.row.energy)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "spec-item" }, [
                              _c("span", { staticClass: "spec-label" }, [
                                _vm._v("载方："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "spec-value" }, [
                                _vm._v(_vm._s(scope.row.volume)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "spec-item" }, [
                              _c("span", { staticClass: "spec-label" }, [
                                _vm._v("车厢："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "spec-value" }, [
                                _vm._v(
                                  _vm._s(scope.row.size) +
                                    " " +
                                    _vm._s(scope.row.box)
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm._l(_vm.dateList, function (date, index) {
                  return _c(
                    "el-table-column",
                    { key: index, attrs: { align: "center" } },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", { staticClass: "date-header" }, [
                          _vm._v(_vm._s(_vm.formatDate(date, "MM-DD"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "date-sub" }, [
                          _vm._v(_vm._s(_vm.formatDate(date, "EEE"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-table-column", {
                        key: index + "-am",
                        attrs: { label: "上午", align: "center", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "schedule-cell",
                                      class: _vm.getScheduleCellClassByPeriod(
                                        scope.row,
                                        date,
                                        "am"
                                      ),
                                    },
                                    [
                                      scope.row.status === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "schedule-busy",
                                              staticStyle: { color: "#F56C6C" },
                                            },
                                            [_vm._v("维修")]
                                          )
                                        : scope.row.status === 3
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "schedule-busy",
                                              staticStyle: { color: "#909399" },
                                            },
                                            [_vm._v("休息")]
                                          )
                                        : !_vm.hasScheduleData(
                                            scope.row,
                                            date,
                                            "am"
                                          )
                                        ? _c(
                                            "span",
                                            { staticClass: "schedule-free" },
                                            [_vm._v("空闲")]
                                          )
                                        : [
                                            _vm.getSendTimeList(
                                              scope.row,
                                              date,
                                              "am"
                                            ).length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "send-time-list",
                                                  },
                                                  _vm._l(
                                                    _vm.getSendTimeList(
                                                      scope.row,
                                                      date,
                                                      "am"
                                                    ),
                                                    function (st, sIdx) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: sIdx,
                                                          staticClass:
                                                            "send-time-item",
                                                        },
                                                        [_vm._v(_vm._s(st))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm.getTaskTimeList(
                                                  scope.row,
                                                  date,
                                                  "am"
                                                ).length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "send-time-list",
                                                  },
                                                  _vm._l(
                                                    _vm.getTaskTimeList(
                                                      scope.row,
                                                      date,
                                                      "am"
                                                    ),
                                                    function (st, sIdx) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: sIdx,
                                                          staticClass:
                                                            "send-time-item",
                                                        },
                                                        [_vm._v(_vm._s(st))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "schedule-order",
                                                  },
                                                  [_vm._v("可用")]
                                                ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        key: index + "-pm",
                        attrs: { label: "下午", align: "center", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "schedule-cell",
                                      class: _vm.getScheduleCellClassByPeriod(
                                        scope.row,
                                        date,
                                        "pm"
                                      ),
                                    },
                                    [
                                      scope.row.status === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "schedule-busy",
                                              staticStyle: { color: "#F56C6C" },
                                            },
                                            [_vm._v("维修")]
                                          )
                                        : scope.row.status === 3
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "schedule-busy",
                                              staticStyle: { color: "#909399" },
                                            },
                                            [_vm._v("休息")]
                                          )
                                        : !_vm.hasScheduleData(
                                            scope.row,
                                            date,
                                            "pm"
                                          )
                                        ? _c(
                                            "span",
                                            { staticClass: "schedule-free" },
                                            [_vm._v("空闲")]
                                          )
                                        : [
                                            _vm.getSendTimeList(
                                              scope.row,
                                              date,
                                              "pm"
                                            ).length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "send-time-list",
                                                  },
                                                  _vm._l(
                                                    _vm.getSendTimeList(
                                                      scope.row,
                                                      date,
                                                      "pm"
                                                    ),
                                                    function (st, sIdx) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: sIdx,
                                                          staticClass:
                                                            "send-time-item",
                                                        },
                                                        [_vm._v(_vm._s(st))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm.getTaskTimeList(
                                                  scope.row,
                                                  date,
                                                  "pm"
                                                ).length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "send-time-list",
                                                  },
                                                  _vm._l(
                                                    _vm.getTaskTimeList(
                                                      scope.row,
                                                      date,
                                                      "pm"
                                                    ),
                                                    function (st, sIdx) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: sIdx,
                                                          staticClass:
                                                            "send-time-item",
                                                        },
                                                        [_vm._v(_vm._s(st))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "schedule-order",
                                                  },
                                                  [_vm._v("可用")]
                                                ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pagination.page,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pagination.size,
                    total: _vm.pagination.total,
                    layout: "total, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.pagination, "page", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.pagination, "page", $event)
                    },
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "700px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "车牌号", prop: "carNumber" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入车牌号" },
                            model: {
                              value: _vm.form.carNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "carNumber", $$v)
                              },
                              expression: "form.carNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌", prop: "brand" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入品牌" },
                            model: {
                              value: _vm.form.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "brand", $$v)
                              },
                              expression: "form.brand",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "款式", prop: "style" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入款式" },
                            model: {
                              value: _vm.form.style,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "style", $$v)
                              },
                              expression: "form.style",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "补能方式", prop: "energy" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择补能方式" },
                              model: {
                                value: _vm.form.energy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "energy", $$v)
                                },
                                expression: "form.energy",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "纯电动", value: "纯电动" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "汽油", value: "汽油" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "柴油", value: "柴油" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "其他", value: "其他" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "容积", prop: "volume" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入容积" },
                            model: {
                              value: _vm.form.volume,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "volume", $$v)
                              },
                              expression: "form.volume",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "载重", prop: "weight" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入载重" },
                            model: {
                              value: _vm.form.weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "weight", $$v)
                              },
                              expression: "form.weight",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "车辆规格", prop: "size" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入车辆规格" },
                            model: {
                              value: _vm.form.size,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "size", $$v)
                              },
                              expression: "form.size",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "车厢规格", prop: "box" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入车厢规格" },
                            model: {
                              value: _vm.form.box,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "box", $$v)
                              },
                              expression: "form.box",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "定位", prop: "coordinate" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "请选择定位",
                                readonly: "",
                              },
                              on: { focus: _vm.openMapSelector },
                              model: {
                                value: _vm.coordinateDisplay,
                                callback: function ($$v) {
                                  _vm.coordinateDisplay = $$v
                                },
                                expression: "coordinateDisplay",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-location el-input__icon",
                                staticStyle: {
                                  cursor: "pointer",
                                  color: "#409EFF",
                                },
                                attrs: { slot: "suffix" },
                                on: { click: _vm.openMapSelector },
                                slot: "suffix",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择状态" },
                              model: {
                                value: _vm.form.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "正常", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "维修", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "休息", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择定位",
            visible: _vm.mapDialogVisible,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mapDialogVisible = $event
            },
            close: _vm.handleMapDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "10px",
                position: "relative",
                width: "70%",
              },
            },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请输入地址关键词搜索" },
                  on: { input: _vm.handleSearchInput },
                  model: {
                    value: _vm.searchKeyword,
                    callback: function ($$v) {
                      _vm.searchKeyword = $$v
                    },
                    expression: "searchKeyword",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.searchLocation },
                    slot: "append",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSearchResults && _vm.searchResults.length > 0
                ? _c(
                    "div",
                    { staticClass: "search-results" },
                    _vm._l(_vm.searchResults, function (result, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "search-result-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectSearchResult(result)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-location" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(result.name) +
                                _vm._s(
                                  result.address ? " " + result.address : ""
                                )
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticStyle: { width: "100%", height: "500px" },
            attrs: { id: "mapContainer" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.mapDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmMapSelection },
                },
                [_vm._v("确认选择")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }